module.exports = __webpack_public_path__ + "static/flags/IN-228bb0b7294fc7a57384600583e2258a.gif";